import styled from 'styled-components'
import ImgHeroSection from './assets/images/simplifies-your-life.png'
import { orange, white, linear } from '../../styles/colors'
import { borderRounded } from '../../styles/radius'
import breakpoints from '../../styles/breakpoints'

export const SimplifiesSection = styled.section`
  background: url(${ImgHeroSection}) no-repeat center center;
  background-size: cover;
  align-items: center;
  display: flex;  
  min-height: 100vh;
  @media(min-width: ${breakpoints.lg}) {
    background-position: 0 10px;
  }
`

export const ButtonLink = styled.a`
  border-radius: ${borderRounded['8']};
  border: 1px solid ${orange.medium};
  font-weight: bold;

  @media(min-width: ${breakpoints.lg}) {
    max-width: 360px;
  }

  &:hover {
    border: 1px solid ${orange.medium};
    background: ${orange.base};
    color: ${orange.base};
    opacity: 0.9;
  }

  &.inverse {
    background: ${linear.orange};
    border: none;
    color: ${white};
    min-width: 220px;
    padding: 10px 16px;   
  }
`

export const Video = styled.div`
  max-width: 456px;
  position: relative;
  
  .image {
    max-width: 456px;
    height: auto;
  }

  .player {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    display: flex;
    justify-content: center;

    img {
      cursor: pointer;
    }

    div {
      margin: 0;
    }
  }
`
export const ScrollLink = styled.div`
  position: absolute;
  bottom: 20px;
  left: 50%;
  text-align: center;
  line-height: 1.67;
  transform: translateX(-50%);
  width: auto;
`